import { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignupFlow } from "../../components/signup/SignupFlow";
import { useGetCheckoutSession } from "../../services/signup";
import { SignupState, STEPS } from "../../components/signup/types";
import useMetaTracking, {
  META_PIXEL_ID,
} from "../../components/hooks/useMetaTracking";
import useGoogleTracking, {
  GOOGLE_CONVERSION_LABEL_SIGNUP,
  GOOGLE_TAG_ID,
} from "../../components/hooks/useGoogleTracking";
// import useTikTokTracking, {
//   TIKTOK_PIXEL_ID,
//   TikTokEvents,
// } from "../../components/hooks/useTikTokTracking";
import { CONSULTATION_FLOW } from "../../components/signup/flow";
import { buildStateFromProto } from "../../components/signup/utils";
import Loading from "../../components/common/Loading";

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isDebug = !!queryParams.get("debug");

  const [initialState, setInitialState] = useState<
    [STEPS | undefined, SignupState] | null
  >(null);
  const { request, loading } = useGetCheckoutSession();
  const { track: trackMeta } = useMetaTracking(META_PIXEL_ID);
  const { fireConversionEvent } = useGoogleTracking(GOOGLE_TAG_ID);
  // const { track: trackTikTok } = useTikTokTracking(TIKTOK_PIXEL_ID);

  const currentFlow = [...CONSULTATION_FLOW];
  const initialStep = STEPS.CONSULTATION_DETAILS;
  const validSteps = new Set(currentFlow.map((s) => s.name));

  const updateStep = useCallback(
    (step: string) => {
      navigate(`/consultation/${step}`, { replace: true });
    },
    [navigate],
  );

  const onSignupComplete = useCallback(() => {
    fireConversionEvent(GOOGLE_CONVERSION_LABEL_SIGNUP);
    trackMeta("InitiateCheckout");
    // trackTikTok(TikTokEvents.InitiateCheckout);
  }, [fireConversionEvent, trackMeta]);

  useEffect(() => {
    const fetch = async () => {
      // We don't pass product info for consultation
      const resp = await request({
        productName: "",
        priceAmountCents: 0,
        supportHours: 0,
        maxUsers: 0,
      });

      if (!resp) return;
      const signupState: SignupState = resp.state
        ? buildStateFromProto(resp.state)
        : {};
      setInitialState([
        resp.state?.stepName && validSteps.has(resp.state?.stepName as STEPS)
          ? (resp.state?.stepName as STEPS)
          : initialStep,
        signupState,
      ]);
    };

    if (isDebug) {
      setInitialState([initialStep, {}]);
    } else {
      fetch();
    }
  }, []);

  if (!initialState || loading) {
    return <Loading />;
  }
  const [step, formData] = initialState;

  return (
    <SignupFlow
      signupFlow={currentFlow}
      initialStep={step}
      initialFormData={formData}
      setStepName={updateStep}
      isDebug={isDebug}
      onSignupComplete={onSignupComplete}
      onExit={() => navigate(-1)}
      useAuthenticatedUpdate={true}
    />
  );
};
